var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "session-list-item ui-elevation-1 panel" },
    [
      _c(
        "div",
        { staticClass: "session-list-item__header" },
        [
          !_vm.session.uri.includes("@web.rec")
            ? _c("ui-button", {
                class: { active: _vm.isFavoriteReady },
                attrs: {
                  disabled: !_vm.isFavoriteReady,
                  icon:
                    (_vm.session.contact.favorite ? "fa" : "fal") +
                    " fa-star fa-fw",
                },
                on: { click: _vm.toggleFavorite },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "session-list-item__header__title" }, [
            _vm.session.name || _vm.session.contact.name
              ? _c(
                  "div",
                  {
                    staticClass:
                      "session-list-item__header__title__name ui-subheading",
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm.session.name
                            ? _vm.session.name
                            : _vm.session.contact.name
                        ) +
                        "\n\t\t\t"
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "session-list-item__header__title__uri",
                class:
                  _vm.session.name || _vm.session.contact.name
                    ? "ui-caption"
                    : "ui-subheading",
                style: [
                  !_vm.session.name && !_vm.session.contact.name
                    ? { lineHeight: "40px" }
                    : {},
                ],
              },
              [_vm._v("\n\t\t\t\t" + _vm._s(_vm.session.uri) + "\n\t\t\t")]
            ),
          ]),
          _vm._v(" "),
          _vm.session.streamuri
            ? _c("i", {
                staticClass: "fa fa-stream",
                attrs: { title: _vm.session.streamuri },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "session-list-item__content" },
        [
          _vm.session.established === 0
            ? _c(
                "div",
                { staticClass: "session-list-item__content__connecting" },
                [
                  _c("div", { staticClass: "ui-title" }, [
                    _vm._v("Connecting..."),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.session.established === 1
            ? _c("dynamic-duration", {
                staticClass: "ui-display-2",
                attrs: { duration: _vm.session.duration },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("ui-button", {
            attrs: {
              icon: "fas fa-square",
              large: "",
              raised: "",
              secondary: "",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("stop", _vm.session)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.session.established === 0
        ? _c("ui-progress", { attrs: { stroke: 2, type: "bar" } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "session-list-item__footer" }, [
        _c("div", [
          _c("div", { staticClass: "ui-caption" }, [_vm._v("Bandwidth")]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.session.bw) + " kbit/s")]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "ui-caption" }, [_vm._v("Audio pkt. loss")]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.session.audio.loss) + "%")]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "ui-caption" }, [_vm._v("Video pkt. loss")]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.session.video.loss) + "%")]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }